// src/lib/supabase.ts — singleton Supabase client.
// Plan ref: 05-RESEARCH-ui-shell.md §Code Examples §Supabase client factory.
//
// flowType 'pkce' = SPA-recommended flow (no token in URL fragment).
// db.schema 'studio' = default schema for all studio.* table reads;
//   override per-call with `.schema('public')` for live tables.

import { createClient } from '@supabase/supabase-js';
import { env } from './env';

export const supabase = createClient(env.SUPABASE_URL, env.SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: { 'X-Studio-Client': 'studio-ui/0.0.1' },
  },
  db: { schema: 'studio' },
});
